<template>
  <div class="video-player-warning" data-test-id="VideoPlayerWarning">
    <img class="video-player-warning__icon" :src="content.icon" />
    <h1 class="video-player-warning__title">
      {{ content.title() }}
    </h1>
    <p v-for="text of content.texts()" :key="text" class="video-player-warning__text">
      {{ text }}
    </p>
    <div class="video-player-warning__button-container">
      <button
        class="video-player-warning__button--secondary"
        data-test-id="VideoPlayerWarning_Button-abort"
        @click="() => $emit('abort')"
      >
        {{ c('video.cancel') }}
      </button>
      <button
        class="video-player-warning__button--primary"
        data-test-id="VideoPlayerWarning_Button-continue"
        @click="() => $emit('continue')"
      >
        {{ c('video.ready') }}
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import type { ReadonlyDeep } from 'type-fest'
import { computed, type PropType } from 'vue'

import { c } from '../../../intl'
import headphoneIcon from '../../../shared/assets/headphone.svg'
import videoClipIcon from '../../assets/video-clip.svg'

type MediaType = 'video' | 'audio'

const MEDIA_CONTENT = {
  video: {
    icon: videoClipIcon,
    title: () => c('video.heads_up_title'),
    texts: () => c('video.description').split('\n\n'),
  },
  audio: {
    icon: headphoneIcon,
    title: () => c('audio.heads_up_title'),
    texts: () => c('audio.description').split('\n\n'),
  },
} as const satisfies ReadonlyDeep<
  Record<
    MediaType,
    {
      icon: string
      title: () => string
      texts: () => string[]
    }
  >
>

export default {
  props: {
    mediaType: {
      type: String as PropType<MediaType>,
      required: true,
    },
  },
  emits: {
    abort: () => true,
    continue: () => true,
  },
  setup(props) {
    return {
      content: computed(() => MEDIA_CONTENT[props.mediaType]),
      c,
    }
  },
}
</script>
<style lang="postcss">
.video-player-warning {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  &__icon {
    width: 2rem;
    height: 2rem;
  }

  &__title {
    font-size: var(--attest-font-size-l);
    font-weight: 400;
  }

  &__text {
    color: #9fa7b7;
  }

  &__button-container {
    display: flex;
    align-self: stretch;
    justify-content: space-between;
  }

  &__button--primary,
  &__button--secondary {
    padding: 0.3rem 1rem;
    border: 0;
    cursor: pointer;
  }

  &__button--primary {
    padding: 1rem;
    border: 1px solid #53b67f;
    border-radius: 3px;
    background-color: var(--color-success);
    color: white;
  }

  &__button--secondary {
    background-color: transparent;
    color: var(--color-disabled-text);
    font-weight: lighter;
  }
}
</style>
